module.exports = __webpack_public_path__ + "static/media/salao_jardim_4.8c21ed79.jpg";